import React, { Component } from "react";

import LetterIcon from "../assets/LetterIcon.svg";
import LocationIcon from "../assets/LocationIcon.svg";

export default class Contact extends Component {
  render() {
    return (
      <div className="contact">
        <div className="contact-form-container">
          <form autoComplete="new-password" name="contact" method="POST">
            <input type="hidden" name="form-name" value="contact" />
            <div className="top-row">
              <div className="input">
                <div className="input-label">First Name*</div>
                <input
                  autoComplete="none"
                  type="text"
                  className="input-text"
                  id="firstName"
                  name="firstName"
                />
              </div>
              <div className="input">
                <div className="input-label">Last Name*</div>
                <input
                  autoComplete="none"
                  type="text"
                  className="input-text"
                  id="lastName"
                  name="lastName"
                />
              </div>
            </div>
            <div className="input">
              <div className="input-label">Email Address*</div>
              <input
                autoComplete="none"
                type="text"
                className="input-text"
                id="email"
                name="email"
              />
            </div>
            <div className="input">
              <div className="input-label">Company Name</div>
              <input
                autoComplete="none"
                type="text"
                className="input-text"
                id="companyName"
                name="companyName"
              />
            </div>
            <div className="input">
              <div className="input-label">Message*</div>
              <textarea
                className="input-text area"
                id="message"
                name="message"
              ></textarea>
            </div>
            <div className="input checkbox-container">
              <div className="checkbox-wrapper">
                <input
                  type="checkbox"
                  className="checkbox"
                  id="interested"
                  name="interested"
                />
                <span className="checkbox-checked"></span>
              </div>
              <div className="input-label">I am interested in a website</div>
            </div>
            <div className="input">
              <button type="submit" className="btn">
                Send Message
              </button>
            </div>
            <input
              type="text"
              autoComplete="on"
              style={{
                display: "none",
                opacity: "0",
                position: "absolute",
                left: "-10000px",
              }}
              name="placeholder"
            />
          </form>
        </div>
        <div className="contact-info">
          <div className="title white">How Can I Help?</div>
          <div className="sub-text">
            Send me a message
            <br />
            or contact me through email
          </div>
          <div className="divider-2"></div>
          <div className="contact-info-row">
            <div className="img-container">
              <img src={LetterIcon} alt="" className="svg" />
            </div>
            <div className="sub-text">jorrharris@gmail.com</div>
          </div>
          <div className="contact-info-row">
            <div className="img-container img-2">
              <img src={LocationIcon} alt="" className="svg" />
            </div>
            <div className="sub-text">
              Chino Hills, CA
              <br />
              91709, USA
            </div>
          </div>
        </div>
      </div>
    );
  }
}
